import { Grid } from '@mui/material';
import React from 'react';
import TextInput from '../../../../../../../../components/form/formInputs/TextInput/TextInput';
import {
    BlobData,
    SdsBlobSectionFormProps,
} from '../../../shared/blobs/hooks/SdsBlobSectionFormProps';
import {
    SdsHeader,
    SdsSubSection6_3,
} from '../../../../../../../../types/formulation';
import useSdsBlobSectionForm from '../../../shared/blobs/hooks/useSdsBlobSectionForm';
import SdsSubSectionForm from '../../../shared/blobs/components/SdsSubSectionForm';
import TranslatableText from '../../../../../../../../components/i18n/TranslatableText';
import { SDSFormDefs } from '../../../../../../../../constants/i18n/translations/termDefinitions/formulation';

const SubSection6_3Form = (props: SdsBlobSectionFormProps<SdsHeader>) => {
    const { isParentLoading } = props.parentData;

    const { disabledField } = props.permissions;

    const blobData: BlobData<SdsSubSection6_3> = {
        sectionNumber: 6,
        subSectionNumber: 3,
        blankBlobEntity: {
            methodsMaterials: '',
        },
    };

    const { fields, isBlobLoading, formMethods, handleFieldChange } =
        useSdsBlobSectionForm<SdsHeader, SdsSubSection6_3>({
            ...props,
            blobData,
        });

    return (
        <SdsSubSectionForm
            formTitle={
                (
                    <TranslatableText
                        termSet={props.termSet}
                        termKey={
                            SDSFormDefs.Methods_Material_For_Containment_Text
                        }
                    />
                ) as unknown as string
            }
            isFormLoading={isParentLoading || isBlobLoading}
            content={
                <Grid item xs={12}>
                    <TextInput
                        fullWidth
                        label={
                            <TranslatableText
                                termSet={props.termSet}
                                termKey={
                                    SDSFormDefs.Methods_Material_For_Containment_Cleanup
                                }
                            />
                        }
                        id="methodsMaterials"
                        formMethods={formMethods}
                        value={fields.methodsMaterials}
                        onChange={handleFieldChange}
                        disabled={disabledField}
                        maxLength={2000}
                        multiline={true}
                        maxRows={15}
                        minRows={5}
                    />
                </Grid>
            }
        />
    );
};
export default SubSection6_3Form;
